export default __webpack_public_path__ + "static/media/user3.ada6076d.png";